import React from "react"

import config from "config"

import { useSearchContainer } from "hooks/search/useSearchContainer"
import { SearchPopupContent } from "components/domains/search"

export const SearchContainer = ({
  showOnscreenKeyboard: showOnscreenKeyboardProp = undefined,
  renderComponent: RenderComponent = SearchPopupContent,
}) => {
  const {
    openSearchState,
    searchInputRef,
    searchResultItems,
    searchValue,
    showOnscreenKeyboard,
    venueFilter,
    reset,
    onChange,
    onChangeKeyboard,
    onSelectResult,
    clearSearchValue,
    setVenueFilter,
  } = useSearchContainer({ showOnscreenKeyboard: showOnscreenKeyboardProp })

  //TODO:: remove this condition when implement kiosk-v search container to kiosk-h version
  const device = config("device")
  const isKiosk = /^kiosk/.test(device)
  const popupType = isKiosk ? "Dialog" : "Drawer"

  return (
    <React.Fragment>
      <RenderComponent
        openSearchState={openSearchState}
        searchInputRef={searchInputRef}
        searchResultItems={searchResultItems}
        searchValue={searchValue}
        showOnscreenKeyboard={showOnscreenKeyboard}
        reset={reset}
        onChange={onChange}
        onChangeKeyboard={onChangeKeyboard}
        onSelectResult={onSelectResult}
        popupType={popupType}
        clearSearchValue={clearSearchValue}
        venueFilter={venueFilter}
        setVenueFilter={setVenueFilter}
      />
    </React.Fragment>
  )
}
